import React from 'react';
import './SpellCard.css';
import Tooltip from '../utils/Tooltip';
import SpellView from './SpellView';
import SpellDetails from './SpellDetails';
import { useSpellDetailsOverlay } from '../../hooks/useSpellDetailsOverlay';

const SpellCard = ({
    spell,
    labels,
    lang = 'fr',
    eliotropePortalCardOnly = false,
    selected = false,
    selectedLineKeys = new Set(),
    disabled = false,
    selectable = true,
    onToggleSpellLine,
    spellCharges = null,
    onChargesChange = null,
    weights = null,
    suppressCriteriaHover = false,
}) => {
    const { onIconActivate, iconActivateLabel } = useSpellDetailsOverlay(spell, labels, lang);
    const isDisabled = disabled || spell.isDisabled;
    const isInteractionDisabled = isDisabled || !selectable;
    const rootClassName = [
        'spell-card',
        selected ? 'spell-card--selected' : '',
        spell.isDisabled ? 'spell-card--disabled' : '',
        !selectable ? 'spell-card--unselectable' : '',
        suppressCriteriaHover ? 'spell-card--no-criteria-hover' : '',
    ].filter(Boolean).join(' ');

    return (
        <div
            className={rootClassName}
        >
            <Tooltip
                content={<SpellDetails spell={spell} labels={labels} lang={lang} />}
                className="spell-card-detail-tooltip"
                positionMode="side"
                positionOptions={{ estimatedWidth: 280, useRightEdge: true }}
            >
                <div
                    className="spell-card-trigger"
                >
                    <SpellView
                        spell={spell}
                        labels={labels}
                        eliotropePortalCardOnly={eliotropePortalCardOnly}
                        selected={selected}
                        selectedLineKeys={selectedLineKeys}
                        onToggleLine={onToggleSpellLine}
                        lineCharges={spellCharges?.[String(spell.id)] || null}
                        onChargesChange={onChargesChange
                            ? (lineKeys, n, max) => onChargesChange(spell.id, lineKeys, n, max)
                            : null}
                        selectable={!isInteractionDisabled}
                        weights={weights}
                        onIconActivate={onIconActivate}
                        iconActivateLabel={iconActivateLabel}
                    />
                </div>
            </Tooltip>
        </div>
    );
};

export default SpellCard;
